import {Button, Form, Image, Input, Spin, Typography} from "antd";
import {Callbacks} from "rc-field-form/lib/interface";
import React, {useEffect} from "react";
import Logo from "../assets/logo.jpg";
import ReCAPTCHA from "react-google-recaptcha";
import variables from "../common/variables";

interface Props {
    spinning: boolean;
    email: string;
    onFinish: Callbacks['onFinish'];
    onFinishFailed: Callbacks['onFinishFailed'];
    recaptchaRef: any;
}

const {Title} = Typography;

const SignInNewPasswordForm = ({spinning, onFinish, onFinishFailed, email, recaptchaRef}: Props) => {
    const [form] = Form.useForm();
    useEffect(() => {
        form.setFieldsValue({
            email: email
        })
    })
    return (

        <Spin tip="Loading..." spinning={spinning}>
            <Form
                form={form}
                style={{height: "100%"}}
                name="basic"
                labelAlign={"left"}
                wrapperCol={{
                    sm: {span: 15, offset: 4},
                    md: {span: 10, offset: 7},
                    lg: {span: 8, offset: 8},
                    xl: {span: 6, offset: 9},
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item>
                    <Title level={4} type="secondary" style={{textAlign: "center"}}>ACT Tracker New Password
                        page</Title>
                    <Image
                        preview={false}
                        width={"100%"}
                        src={Logo}
                    />
                </Form.Item>
                <Form.Item
                    name="email"
                    hasFeedback
                >
                    <Input placeholder="Email" value={email} defaultValue={email} disabled/>
                </Form.Item>

                <Form.Item
                    name="password"
                    rules={[{required: true, message: 'Please input your password!'}]}
                    hasFeedback
                >
                    <Input.Password placeholder="New password"/>
                </Form.Item>

                <Form.Item
                    name="confirmPassword"
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: 'Please confirm your password!',
                        },
                        ({getFieldValue}) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('The two passwords that you entered do not match!'));
                            },
                        }),
                    ]}
                >
                    <Input.Password placeholder="Confirm new password"/>
                </Form.Item>

                <Form.Item name="captcha" hasFeedback rules={[{required: true, message: 'Complete captcha!'}]}>
                    <ReCAPTCHA
                        onChange={(ev) => form.setFieldsValue({captcha: ev})}
                        sitekey={variables.captchaKey!}
                        ref={el => recaptchaRef.current[2] = el}
                    />
                </Form.Item>

                <Form.Item wrapperCol={{
                    sm: {span: 15, offset: 4},
                    md: {span: 10, offset: 7},
                    lg: {span: 8, offset: 8},
                    xl: {span: 6, offset: 9},
                }}>
                    <Button style={{width: "100%"}} type="primary" htmlType="submit">
                        Sign In
                    </Button>
                </Form.Item>
            </Form>
        </Spin>

    )
}

export default SignInNewPasswordForm;
